export const substrates =[
    'Akadama',
    'Pumice',
    'Pine Bark',
    'Lava Rock',
    'Peat Moss',
    'Coconut Coir',
    'Perlite',
    'Vermiculite',
    'Bark',
    'Sand',
    'Gravel',
    'Sphagnum Moss',
    'Charcoal',
    'Bonsai Soil Mix',
    'Other',
    
'Turface',
'Zeolite',
'Haydite',
'Coco Chips',
'Rice Hulls',
'Akadama Mix',
'Kanuma',
'Kiryu',
'Leca',
'Sphagnum Peat',
'Bark Fines',
'Pine Fines',
'Cinder',
    
]